<script setup lang="ts">
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { router } from '@inertiajs/vue3'

import { ref, watch } from 'vue'

const props = defineProps<{
    currentRoute: string
    currentWorkshopId: number | null
}>()

const current = ref(props.currentRoute)

watch(current, (newValue) => {
    const params = props.currentWorkshopId ? { workshop_id: props.currentWorkshopId } : {}
    router.get(`/admin/reports/${newValue}`, params)
})
</script>

<template>
    <Select default-value="sellers" v-model="current">
        <SelectTrigger class="bg-white">
            <SelectValue placeholder="Selecione um relatório" />
        </SelectTrigger>

        <SelectContent>
            <SelectItem value="sellers">Relatório de vendas</SelectItem>
            <SelectItem value="tickets">Relatório de ingressos</SelectItem>
            <SelectItem value="coupons">Relatório de cupons</SelectItem>
        </SelectContent>
    </Select>
</template>
